import { createWeb3Modal, defaultConfig } from "@web3modal/ethers/react";

const projectId = "98ba3392910d4719069959863974187e";

const BEP20 = {
  chainId: 56,
  name: "Binance Smart Chain",
  currency: "BNB",
  explorerUrl: "https://bscscan.com",
  rpcUrl: "https://bsc-dataseed.binance.org",
};

const PIRC20 = {
  chainId: 5090,
  name: "Pione Chain",
  currency: "PIO",
  explorerUrl: "https://pionescan.com",
  rpcUrl: "https://rpc.pionescan.com",
};

const ERC20 = {
  chainId: 1,
  name: "Ethereum",
  currency: "ETH",
  explorerUrl: "https://etherscan.io",
  rpcUrl: "https://eth.llamarpc.com",
};
// const TBEP20 = {
//   chainId: 97,
//   name: "Binance Smart Chain (testnet)",
//   currency: "tBNB",
//   explorerUrl: "https://testnet.bscscan.com",
//   rpcUrl: "https://data-seed-prebsc-1-s1.bnbchain.org:8545",
// };
// const PORC20 = {
//   chainId: 5080,
//   name: "Zero Chain",
//   currency: "PZO",
//   explorerUrl: "https://zeroscan.org",
//   rpcUrl: "https://rpc.zeroscan.org",
// };
// const TERC20 = {
//   chainId: 11155111,
//   name: "Sepolia",
//   currency: "ETH",
//   explorerUrl: "https://etherscan.io",
//   rpcUrl: "https://sepolia.drpc.org",
// };

const metadata = {
  name: "Pione Swap",
  description: "Pione Swap",
  url: "https://pioneswap.com/",
  icons: [
    "https://nft.pionewallet.com/images/logo.png",
  ],
};

const ethersConfig = defaultConfig({
  metadata,
  enableEIP6963: true,
  enableInjected: true,
  enableCoinbase: true,
  rpcUrl: "https://bsc-dataseed.binance.org",
  defaultChainId: 56,
});

createWeb3Modal({
  ethersConfig,
  chains: [BEP20, PIRC20, ERC20],
  // chains: [BEP20, PIRC20, ERC20, TBEP20, PORC20, TERC20],
  projectId,
  enableAnalytics: true,
  enableOnramp: true,
  //   themeMode: "light",
  //   themeVariables: {
  //     "--w3m-accent-color": "#F5841F",
  //     "--w3m-accent-fill-color": "#F5841F",
  //     "--w3m-background-color": "#F5841F",
  //   } ,
});

export function Web3Modal({ children }) {
  return children;
}
